import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import api from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshMe } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        await refreshMe();
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        navigate("/login?error=google-auth-failed", { replace: true });
      }
    })();
  }, [navigate, refreshMe]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="font-mono text-xs text-zinc-500 pulse-dot" data-testid="auth-callback-loading">VERIFYING GOOGLE SESSION…</div>
    </div>
  );
}
